'use strict';
const angular = require('angular');
import SignupController from './signup.controller';

export default angular.module('nomasvelloDashboardApp.signup', [])
    .controller('SignupController', SignupController)
    .name;



// WEBPACK FOOTER //
// ./client/app/admin/signup/index.ts